export default "__VITE_ASSET__Hsop_PTH__"